import { useCan } from '@/components/can/Can';
import { defaultMeta } from '@/constants/defaultMeta';
import { PERMS } from '@/features/auth/permissions/permissionKeys';
import { parseDateRangeSearch } from '@/lib/parseDateRange';
import { sortBy } from '@/lib/sortBy';
import { useQuery } from '@/react-query/hooks/useQuery/useQuery';
import { paymentLogsQueries } from '@/services/payment/payment.queries';
import { useSearch } from '@tanstack/react-router';

export const useGetStorePaymentLogs = () => {
  const canViewLogs = useCan({ allOf: [PERMS.paymentManagement.storePaymentLogs.list] });
  const { page, fetch, q, sort, createdDate, locationFilter, clubFilter, clubId } = useSearch({
    from: '/(app)/payment-management/store-payment-log/',
  });

  const parsedDateRange = createdDate
    ? parseDateRangeSearch(Array.isArray(createdDate) ? createdDate.join(',') : createdDate)
    : undefined;

  const { data, isFetched, isLoading } = useQuery({
    ...paymentLogsQueries.list({
      clubFilter: clubFilter || clubId || undefined,
      locationFilter: locationFilter || undefined,
      row: page ?? 0,
      fetch: fetch ?? 10,
      search: q || undefined,
      fromDateMs: parsedDateRange?.start,
      toDateMs: parsedDateRange?.end,
    }),
    select: (res) => ({
      ...res,
      data: sortBy(res.data, sort, {
        createdDate: 'visitDateTime',
        storeInfo: 'storeName',
      }),
    }),
    enabled: canViewLogs,
  });

  return {
    storePaymentLogs: data?.data ?? [],
    logsList: data?.data ?? [],
    isFetched,
    isLoading,
    pagination: data?.meta?.pagination ?? defaultMeta,
  };
};
